<template>
  <v-card flat>
    <v-menu
      ref="menu"
      v-model="selectMonthYearDateRange"
      :close-on-content-click="false"
      :return-value.sync="monthYearRange"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="formattedMonthYearRange"
          label="Select month to report on"
          prepend-icon="mdi-calendar"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="monthYearRange"
        type="month"
        no-title
        scrollable
      >
      </v-date-picker>
    </v-menu>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'month-input',
  displayName: 'By Month',
  title: 'Select Month and Year to generate a report',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      monthYearRange: null,
      selectMonthYearDateRange: false
    }
  },
  computed: {
    formattedMonthYearRange () {
      if (this.monthYearRange) {
        const [year, month] = this.monthYearRange.split('-')
        const dt = this.monthYearToDate(month, year)
        return dt.toFormat('MMMM yyyy')
      } else {
        return ''
      }
    }
  },
  watch: {
    monthYearRange: function (newVal, oldVal) {
      this.$refs.menu.save(newVal)
      const [year, month] = this.monthYearRange.split('-')
      const dt = this.monthYearToDate(month, year)
      const startDt = dt.startOf('month').toISODate()
      const endDt = dt.endOf('month').toISODate()
      this.$emit('input', { startDate: startDt, endDate: endDt })
    }
  },
  methods: {
    monthYearToDate (month, year) {
      return DateTime.now().set({ year: Number(year), month: Number(month), day: 1 })
    },
    resetMonthYearRange () {
      this.monthYearRange = DateTime.now().toFormat('yyyy-MM')
    }
  },
  mounted () {
    this.resetMonthYearRange()
  }

}
</script>
